import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=4a8b305a"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"
import style0 from "./AppSearch.vue?vue&type=style&index=0&id=4a8b305a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports